import React, {useEffect, useState} from 'react';
import PublicationCard from './PublicationCard'; 
import axios from '../axiosConfig';

function formatDateTime(isoDate) {
  const date = new Date(isoDate);
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  
  const formattedDate = date.toLocaleDateString('en-US', options);
  
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const time = `${hours}:${minutes}`;
  
  return `${formattedDate}, ${time}`;
}

  const PublicationList = () => {

    const [allPublications, setAllPublications] = useState([]);

    useEffect(() => {
      const fetchPublications = async () => {
        try {
          const response = await axios.get('/api/publications'); 
          

          setAllPublications(response.data.data);
          
        } catch (error) {
          console.error('Erreur lors de la récupération des publications : ', error);
        }
      };
      fetchPublications();
    }, []);

    return (
      <div>
        <div className="publication-list">
          {allPublications.length > 0 ? (
            allPublications.map((pub) => (
              <PublicationCard
                key={pub.id}
                category = {pub.sectors}
                title = {pub.title}
                date = {formatDateTime(pub.created_at)}
                dl_link = {pub.download_link}
                img_link = {pub.image_link}
              />
            ))
          ) : (
            <p>No online publication.</p>
          )}
        </div>
      </div>
    );

  }

  export default PublicationList

  